import { useCallback, useState } from 'react';
import _ from 'lodash';

import { SECOND } from '@/common/constants';
import { AUTH_ERROR_KEY } from '@/common/constants';
import useResetPasswordQuery from '@/modules/user/components/SignIn/ForgotPassword/queries/useResetPassword.query';
import useSendForgotPasswordCodeQuery from '@/modules/user/components/SignIn/ForgotPassword/queries/useSendForgotPasswordCode.query';
import { FORGOT_USERNAME_ATTEMPTS_LIMIT_ERROR_CODE } from '@/modules/user/components/SignIn/signIn.constants';

const TIMEOUT = SECOND * 15;

export default () => {
  const [disabled, setDisabled] = useState(false);
  const [errorText, setErrorText] = useState<string | undefined>(undefined);
  const { sendForgotPasswordCode, isLoading } = useSendForgotPasswordCodeQuery();
  const { resetPassword, isLoading: isResetLoading } = useResetPasswordQuery();

  const handleResetError = useCallback(() => {
    setErrorText(undefined);
  }, []);

  const handleRequestCode = useCallback(async (username: string) => {
    await sendForgotPasswordCode({
      username
    });
  }, [sendForgotPasswordCode]);

  const handleSetNewCode = useCallback(
    async (
      username: string,
      code: string,
      newPassword: string,
      callback: (value: object) => void,
    ) => {
      try {
        await resetPassword({
          username,
          newPassword,
          code,
        });
        setErrorText(undefined);
        callback({});
      } catch (e) {
        setErrorText(AUTH_ERROR_KEY.CODE_IS_WRONG);
      }
    }, [resetPassword],
  );
 
  const handleRequestCodeWithTimeout = useCallback(async (username: string) => {
    setDisabled(true);
    setTimeout(() => {
      setDisabled(false);
    }, TIMEOUT);

    try {
      await handleRequestCode(username);
    } catch (error) {
      const elevateErrorCode = _.get(error, 'response.data.elevate_error_code', '') as string;

      if (elevateErrorCode === FORGOT_USERNAME_ATTEMPTS_LIMIT_ERROR_CODE) {
        setErrorText(AUTH_ERROR_KEY.TOO_MANY_FAILED_ATTEMPTS);
        return;
      }
    }
  }, [handleRequestCode]);
  return {
    errorText,
    setErrorText,
    handleResetError,
    disabled,
    handleRequestCodeWithTimeout,
    handleSetNewCode,
    handleRequestCode,
    isLoading,
    isResetLoading,
  };
};
